import React from 'react';
import { FacebookIcon, InstagramIcon, MailIcon } from 'lucide-react';
import { contact } from '../data/landing';
import { Brand } from './Brand';
export function SiteFooter() {
  const socials = [{
    href: contact.email ? `mailto:${contact.email}` : '',
    label: 'Email',
    icon: MailIcon
  }, {
    href: contact.instagram,
    label: 'Instagram',
    icon: InstagramIcon
  }, {
    href: contact.facebook,
    label: 'Facebook',
    icon: FacebookIcon
  }].filter(s => s.href);
  const legal = [{
    href: contact.privacyUrl,
    label: 'Privacy policy'
  }, {
    href: contact.termsUrl,
    label: 'Terms'
  }].filter(l => l.href);
  return <footer className="border-t border-white/10 bg-navy-deep py-12 text-sm text-white/60" data-id="element-187" data-mp="33jghfc2dsllt">
      <div className="mx-auto flex max-w-[1180px] flex-col gap-8 px-5 md:flex-row md:items-start md:justify-between md:px-8" data-id="element-188" data-mp="2ykvo7wljr26v">
        <div data-id="element-189" data-mp="11p7opria55f1">
          <Brand data-id="element-190" data-mp="11oxwdx9rim66" />
          <p className="mt-3 max-w-[420px]" data-id="element-191" data-mp="wsgzoeohyzhh">
            Youth Ministry Ready™ · Digital resources in English. For church-led groups. Follow your church's
            safeguarding procedures.
          </p>
        </div>
        {(socials.length > 0 || legal.length > 0) && <div className="flex flex-col gap-4 md:items-end" data-id="element-192" data-mp="1anlonod1nh15">
            {socials.length > 0 && <ul className="flex gap-3" data-id="element-193" data-mp="vv20puygtg4a">
                {socials.map(({
            href,
            label,
            icon: Icon
          }) => <li key={label} data-id="element-194" data-mp="1ohcxeuiyawvt">
                    <a href={href} aria-label={label} className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 transition-colors duration-150 hover:border-amber hover:text-amber" data-id="element-195" data-mp="1oie9n2bpdpf4">
                      <Icon className="h-4 w-4" aria-hidden="true" data-id="element-196" data-mp="1jpl78l3pit67" />
                    </a>
                  </li>)}
              </ul>}
            {legal.length > 0 && <ul className="flex gap-5" data-id="element-197" data-mp="2c7z52kp1mf5a">
                {legal.map(link => <li key={link.label} data-id="element-198" data-mp="2m3637xdd0pq6">
                    <a href={link.href} className="transition-colors duration-150 hover:text-amber" data-id="element-199" data-mp="2m24qlogp3v6c">
                      {link.label}
                    </a>
                  </li>)}
              </ul>}
          </div>}
      </div>
      <p className="mx-auto mt-10 max-w-[1180px] px-5 text-xs text-white/40 md:px-8" data-id="element-200" data-mp="283y3n3dabflg">© 2026 Ministry Ready Hub.</p>
    </footer>;
}